module.exports = __webpack_public_path__ + "static/Star.c4e08adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hero/assets/Star.png
// module id = 277
// module chunks = 35783957827783